<template>
  <div class='monitorHead'>
    <div class='title'>
      {{title}}
    </div>
    <div class='img_body'>
      <img :src="img"
           v-if="img"
           alt="">
      <div class='img_text'
           v-if="text">{{text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'monitorHead',
  props: ['title', 'img', 'text'],
}
</script>

<style lang='scss' scoped>
.monitorHead {
	padding-bottom: 40px;
	border-bottom: 1px solid #e8e8e8;

	.title {
		text-align: center;
		padding: 40px 0;
		font-size: 28px;
		font-weight: 500;
		color: #333333;
	}

	.img_body {
		display: flex;

		img {
			width: 220px;
		}

		.img_text {
			flex: 1;
			width: 0;
			padding: 50px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			font-weight: 400;
			color: #333333;
		}
	}
}
</style>
